export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  SET_AREAS: "SET_AREAS",
  SET_APPS: "SET_APPS"
};
